import { ApiClientError } from '../services/api/client';

/**
 * Extract a human-readable message from an unknown error.
 * Falls through to `fallback` when no message is available.
 */
export function toErrorMessage(err: unknown, fallback: string): string {
  if (err instanceof ApiClientError) return err.message || fallback;
  if (err instanceof Error) return err.message || fallback;
  return fallback;
}
